import React from 'react';

import AddAssetPimModal from 'pages/product-full-view/components/modal/add-asset-pim-modal';

const UpdateMinimumRequirementProductDocumentModal = (props) => {
  const { visible, setVisible, productDetail, onInvalidateProductValidation } =
    props;

  const onCloseModal = () => {
    setVisible(false);
  };

  return visible ? (
    <AddAssetPimModal
      onCloseModal={onCloseModal}
      addType={'Document'}
      productDetail={productDetail}
      onInvalidateProductValidation={onInvalidateProductValidation}
    />
  ) : null;
};

export default UpdateMinimumRequirementProductDocumentModal;
